export enum Languages {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  DE = 'de',
  PT = 'pt',
  JA = 'ja',
  TR = 'tr',
  AR = 'ar',
  PL = 'pl',
  HE = 'he',
  ZH = 'zh',
  HI = 'hi',
  ID = 'id',
  IT = 'it',
  SV = 'sv',
  RO = 'ro',
  FA = 'fa',
  UR = 'ur',
  NL = 'nl',
  VI = 'vi',
  MS = 'ms',
  NO = 'no',
  DA = 'da',
  EL = 'el',
  ZH_TW = 'zh-tw',
  TH = 'th',
  KO = 'ko',
  FI = 'fi',
  CS = 'cs',
}
